{
  "profile": "Profilo",
  "nbOfUsers": "Numero utilizzatori",
  "validation": {
    "name": "Il nome del profilo è obbligatorio",
    "maxLength": "Il nome deve essere di almeno 50 caratteri"
  },
  "roles": "Ruoli",
  "name": "Nome del profilo",
  "empty": "Nessun ruolo disponibile",
  "confirmDelete": {
    "title": "Eliminazione di un gruppo",
    "description": "Il profilo selezionato \"{userProfileName}\" sarà eliminato"
  },
  "cannotDelete": {
    "title": "Impossibile eliminare il profilo",
    "description": "Il profilo selezionato \"{userProfileName}\" è associato a {usersCount} utenti"
  },
  "button": {
    "delete": "Eliminare il profilo"
  },
  "identity": "Identità",
  "new": "Nuovo profilo",
  "label": {
    "operator": "Operatore",
    "administrator": "Amministratore"
  }
}
